import { useEffect, useState } from "react";
import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let _cache = null;
let _inflight = null;

export function loadBlocks() {
  if (_cache) return Promise.resolve(_cache);
  if (_inflight) return _inflight;
  _inflight = axios.get(`${BACKEND_URL}/api/cms/blocks`).then((r) => {
    _cache = r.data?.blocks || {};
    return _cache;
  }).catch(() => ({}));
  return _inflight;
}

export function useBlocks() {
  const [blocks, setBlocks] = useState(_cache || {});
  useEffect(() => { if (!_cache) loadBlocks().then(setBlocks); }, []);
  return blocks;
}

export function block(blocks, key, fallback = "") {
  const v = blocks?.[key];
  return v && v.length ? v : fallback;
}
